import { useState } from 'react';
import './FeaturesEditor.css';

function FeaturesEditor({ features = [], onChange }) {
  const [newText, setNewText] = useState('');

  const handleAdd = () => {
    if (!newText.trim()) {
      return;
    }

    const updatedFeatures = [
      ...features,
      {
        id: `feature-${Date.now()}`,
        text: newText.trim(),
      },
    ];

    onChange(updatedFeatures);
    setNewText('');
  };

  const handleUpdate = (id, value) => {
    const updatedFeatures = features.map((feature) =>
      feature.id === id ? { ...feature, text: value } : feature
    );
    onChange(updatedFeatures);
  };

  const handleDelete = (id) => {
    const updatedFeatures = features.filter((feature) => feature.id !== id);
    onChange(updatedFeatures);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <div className="features-editor">
      {/* Existing Features */}
      {features.length > 0 && (
        <div className="features-list">
          {features.map((feature) => (
            <div key={feature.id} className="feature-item">
              <input
                type="text"
                className="feature-text"
                placeholder="Feature text"
                value={feature.text || ''}
                onChange={(e) => handleUpdate(feature.id, e.target.value)}
              />
              <button
                type="button"
                className="feature-delete"
                onClick={() => handleDelete(feature.id)}
                title="Remove feature"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Add New Feature */}
      <div className="feature-add">
        <input
          type="text"
          className="feature-text"
          placeholder="Add a feature (e.g., 100% Polyester Canvas, 14 days return policy)"
          value={newText}
          onChange={(e) => setNewText(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button
          type="button"
          className="feature-add-btn"
          onClick={handleAdd}
          disabled={!newText.trim()}
          title="Add feature"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
        </button>
      </div>

      {features.length === 0 && (
        <p className="features-empty">
          No features added yet. Add product features as bullet points (e.g., "100% Polyester Canvas", "14 days return policy").
        </p>
      )}
    </div>
  );
}

export default FeaturesEditor;
